import { render } from "./CookiesFunctionalView.vue?vue&type=template&id=51ad4bcc&scoped=true&ts=true"
import script from "./CookiesFunctionalView.vue?vue&type=script&lang=ts"
export * from "./CookiesFunctionalView.vue?vue&type=script&lang=ts"

import "./CookiesFunctionalView.vue?vue&type=style&index=0&id=51ad4bcc&lang=css"
import "./CookiesFunctionalView.vue?vue&type=style&index=1&id=51ad4bcc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ad4bcc"]])

export default __exports__